<template>
  <div class="apple-discover-artists" :aria-busy="String(loading)">
    <div class="apple-discover-artist-grid" aria-label="热门歌手">
      <router-link v-for="item in items" :key="item.id" class="apple-discover-artist" :to="{name:'artist',params:{id:String(item.id)}}" :aria-label="artistLabel(item)">
        <AppleArtwork :src="item.img1v1Url || item.picUrl || fallback" :fallback="fallback" :retry-key="item.id" :alt="item.name" size="100%" round />
        <strong :title="item.name">{{ item.name }}</strong><span v-if="songCount(item)">{{ songCount(item) }}</span>
      </router-link>
    </div>
    <AppleState :loading="loading" :error="error" :count="items.length" empty-text="来源暂未返回热门歌手。" @retry="loadFeed(false)" />
  </div>
</template>
<script>
import DiscoverArtists from '../salt/online/DiscoverArtists.vue';
import AppleArtwork from './ui/AppleArtwork.vue';
import AppleState from './ui/AppleState.vue';
import './apple-discover-artists.scss';
export default {
  name:'AppleDiscoverArtists', extends:DiscoverArtists, components:{AppleArtwork,AppleState},
  methods:{
    artistLabel(item) { const count=this.songCount(item); return count ? `${item.name}，${count}` : item.name; },
    songCount(item) {
      for (const raw of [item.musicSize,item.songCount,item.songNum]) {
        if (!['string','number'].includes(typeof raw) || typeof raw === 'string' && !raw.trim()) continue;
        const value=Number(raw);
        if (Number.isSafeInteger(value) && value >= 0) return value + ' 首歌曲';
      }
      return '';
    },
  },
};
</script>
